import { modifier } from '@styles/mixins'
import { colors, typography } from '@styles/vars'
import React from 'react'
import styled, { css } from 'styled-components'

export default function Tab(props: Props) {
    const handleClick = () => {
        props.active
            ? props.onActiveClick() 
            : props.onClick()
    }

    return <TabWrapper active={props.active} onClick={handleClick}>{props.label}</TabWrapper>
}

// STYLES
const TabWrapper = styled.div<Modifiers>`
    display: flex;
    align-items: center;
    padding: 5px 7px;
    background: ${colors.white};
    border: 1px solid ${colors.border};
    border-radius: 5px;
    font-size: ${typography.sizes.s};
    font-weight: 700;
    cursor: pointer;
    transition: .2s ease-out;

    ${modifier("active", css`
        background: ${colors.black};
        color: ${colors.white};
    `)}
`

// TYPES
interface Props {
    onClick: () => void
    onActiveClick: () => void
    label: React.ReactNode
    active: boolean
}

interface Modifiers {
    active: Props["active"]
}